import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import { useContext } from 'react';

import FooterDisclaimers from '../../../molecules/screener/footer-disclaimers';
import ScreenerAppContext from '../../../../stores/screener/screener-app-context';
import styles from './footer.module.scss';
import { CHANNELS } from '../../../../shared/screener-constants';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import { urls } from '../../../../utils/url-helper/index';

const className = augmentClassName(styles);

export const Footer = () => {
  const { channel, searchedPlanNumber } = useContext(ScreenerAppContext);

  const distributionsUrl = urls.pages.linkToDistribution({
    planQueryValue: searchedPlanNumber,
    channel
  });

  return (
    <div role="contentinfo" aria-label="footer-disclosures">
      <Container fluid={'xl'}>
        <Col sm={12}>
          <FooterDisclaimers />
        </Col>
      </Container>
      <footer {...className('card-container')}>
        <Container>
          <Row {...className('placement', 'pt-8', 'pb-5')}>
            <FooterCard
              title="Distributions"
              context="View investment distributions over the long and short term"
              btnText="View now"
              link={distributionsUrl}
            />
            <FooterCard
              title="TIAA Traditional"
              context="Guaranteed growth and income for life"
              btnText="Show me how"
              link="https://www.tiaa.org/public/retire/financial-products/annuities/retirement-plan-annuities/tiaa-traditional-annuity"
            />
            <FooterCard
              title="Retirement Planner"
              link="https://shared.tiaa.org/private/digitalinvestadvice/experience/personalgoals/userlanding"
              context="We can help you create a plan for your future"
              btnText="Get started"
            />
          </Row>
          <Row {...className('px-8', 'pb-4')}>4347032</Row>
        </Container>
      </footer>
    </div>
  );
};

const FooterCard = ({ title, context, btnText, link }) => {
  return (
    <Col md={3} {...className('card', 'py-7', 'px-4')}>
      <Col {...className('title')}>{title}</Col>
      <Col {...className('context', 'mt-6')}>{context}</Col>
      <Button
        {...className('btn-label', 'mt-6')}
        role="button"
        as="a"
        href={link}
        rel="noopener noreferrer"
        target="_blank"
        // TIAA Analytics Tracking
        data-analytics-linkname={`${title.replace(/ /g, '_')}:${btnText.replace(
          / /g,
          '_'
        )}:Footer_tiles`}
        data-analytics-section="component"
        data-analytics-componenttype="Link"
      // END TIAA Analytics Tracking
      >
        {btnText}
      </Button>
    </Col>
  );
};

FooterCard.propTypes = {
  title: PropTypes.string,
  context: PropTypes.string,
  btnText: PropTypes.string,
  link: PropTypes.string
};

export default Footer;
